/**
 * "Something long is running, and here is where it has got to."
 *
 * Shared by the two actions that take minutes — validation and recompute — so
 * the spinner, the wording and the spacing match wherever a run is in flight.
 * There is no progress bar: the backend reports phases, not countable units, and
 * a bar would have to invent a denominator.
 */

import { Group, Loader, Text } from "@mantine/core";
import { stageCopy } from "../lib/runStages";

export function RunStageLine({
  label,
  stage,
  "data-test": dataTest,
}: {
  /** What is running, e.g. "Validation running…". */
  label: string;
  /** The backend's reported stage, if it has reported one yet. */
  stage: string | null | undefined;
  "data-test"?: string;
}) {
  const detail = stageCopy(stage);
  return (
    <Group gap={6} wrap="nowrap" data-test={dataTest}>
      <Loader size={12} />
      <Text size="sm" c="dimmed">
        {label}
        {detail ? ` · ${detail}` : ""}
      </Text>
    </Group>
  );
}
